import { useEffect, useState } from 'react';
import { DEMO_DECOY_IMAGES, pickRandomDecoyIndex } from '../data/demoDecoyImages';
import { preloadImages } from '../utils/imageCache';

export function DemoZoomCarousel() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    preloadImages([...DEMO_DECOY_IMAGES]).then(() => setReady(true));
  }, []);

  useEffect(() => {
    if (!ready) return;
    const id = setInterval(() => {
      setActiveIdx((prev) => pickRandomDecoyIndex(prev));
    }, 1600);
    return () => clearInterval(id);
  }, [ready]);

  return (
    <div className="demo-zoom" aria-hidden>
      {DEMO_DECOY_IMAGES.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          className={`demo-zoom-img${i === activeIdx ? ' is-active' : ''}`}
          loading="eager"
          decoding="async"
        />
      ))}
      <span className="demo-zoom-badge">Dézoome en jouant</span>
    </div>
  );
}
